module.exports = __webpack_public_path__ + "img/drug-11.85050b15.png";